var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPraznaInsightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    height: 230,
    viewBox: "0 0 560 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162803",
    "data-name": "Rectangle 162803",
    width: 560,
    height: 230,
    transform: "translate(1360 850)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_163426",
    "data-name": "Mask Group 163426",
    transform: "translate(-1360 -850)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M244.667,0a246.491,246.491,0,0,0-49.309,4.97,243.32,243.32,0,0,0-87.487,36.815A245.395,245.395,0,0,0,19.227,149.431,243.5,243.5,0,0,0,4.97,195.357a247.272,247.272,0,0,0-3.433,76.862H105.175a142.724,142.724,0,0,1-2.68-27.553c0-78.393,63.778-142.171,142.172-142.171s142.171,63.778,142.171,142.171a142.728,142.728,0,0,1-2.68,27.553H487.8a247.268,247.268,0,0,0-3.433-76.862,243.3,243.3,0,0,0-36.815-87.486A245.4,245.4,0,0,0,339.9,19.227,243.512,243.512,0,0,0,293.976,4.97,246.506,246.506,0,0,0,244.667,0Z",
    transform: "translate(1381.666 871)",
    fill: "#c6c8c9",
    opacity: 0.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPraznaInsightLogo);
export default __webpack_public_path__ + "static/media/PraznaInsightLogo.4a029d705f547216ec77c42daed7c2ff.svg";
export { ForwardRef as ReactComponent };